var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlertCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 47,
    viewBox: "0 0 46 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 0.70752C10.4558 0.70752 0.25 10.9133 0.25 23.4575C0.25 36.0017 10.4558 46.2075 23 46.2075C35.5442 46.2075 45.75 36.0017 45.75 23.4575C45.75 10.9133 35.5442 0.70752 23 0.70752ZM23 35.6977C21.7919 35.6977 20.8125 34.7183 20.8125 33.5102C20.8125 32.3021 21.7919 31.3227 23 31.3227C24.2081 31.3227 25.1875 32.3021 25.1875 33.5102C25.1875 34.7183 24.2081 35.6977 23 35.6977ZM24.7478 27.0406L25.3756 13.6969L25.3713 13.698C25.4087 12.8249 24.9643 12.0017 24.2139 11.554C23.4634 11.1063 22.5278 11.1063 21.7774 11.554C21.0269 12.0017 20.5825 12.8249 20.62 13.698V13.7035L21.2478 27.0406C21.2478 28.0071 22.0313 28.7906 22.9978 28.7906C23.9643 28.7906 24.7478 28.0071 24.7478 27.0406Z",
    fill: "#ADADAD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertCircle);
export default __webpack_public_path__ + "static/media/alert-circle.1e084e4f859af8605d17e38580f94834.svg";
export { ForwardRef as ReactComponent };